// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2eCyj","track":"styles__track___3ZWh_","dot":"styles__dot___MCzO5","selected":"styles__selected___1apYp"};